module.exports = __webpack_public_path__ + "img/no3.aee2af13.svg";